<template>
    <div class="d-flex align-items-center">
        <a
            v-show="allowedElementTypes.includes('text')"
            @click="createElement('text')"
            class="badge badge-light badge-pill mr-2"
        >
            <span class="icon icon-glyphicons-basic-plus mr-1"></span> Text
        </a>
        <a
            v-show="allowedElementTypes.includes('image')"
            class="badge badge-light badge-pill mr-2"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="icon icon-glyphicons-basic-plus mr-1"></span>
            Image
        </a>
        <div class="dropdown-menu shadow-sm">
            <a @click="createElement('image')" class="dropdown-item">
                <span class="icon icon-glyphicons-basic-square-empty-upload mr-2"></span>
                <span>Upload</span>
            </a>
            <a class="dropdown-item" :class="{ disabled: freeTierActive }" @click="createElement('image_ai')">
                <ai-badge class="mr-2" :enableTooltip="false"></ai-badge>
                <span class="align-middle">AI-Generated</span>
                <span v-show="freeTierActive" class="badge badge-light badge-tiny ml-2 align-middle">Paid Only</span>
            </a>
        </div>
        <div v-if="allowedElementTypes.includes('audio')" class="dropdown d-flex align-items-center">
            <a
                class="badge badge-light badge-pill mr-2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <span class="icon icon-glyphicons-basic-plus mr-1"></span>
                Audio
            </a>
            <div class="dropdown-menu shadow-sm">
                <a @click="createElement('audio')" class="dropdown-item">
                    <span class="icon icon-glyphicons-basic-square-empty-upload mr-2"></span>
                    <span>Upload</span>
                </a>
                <a class="dropdown-item" :class="{ disabled: freeTierActive }" @click="createElement('audio_ai')">
                    <ai-badge class="mr-2" :enableTooltip="false"></ai-badge>
                    <span class="align-middle">AI-Generated</span>
                    <span v-show="freeTierActive" class="badge badge-light badge-tiny ml-2 align-middle"
                        >Paid Only</span
                    >
                </a>
            </div>
        </div>
        <div v-if="videoElementsAllowed" class="dropdown d-flex align-items-center">
            <a
                class="badge badge-light badge-pill mr-2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <span class="icon icon-glyphicons-basic-plus mr-1"></span>
                Video
            </a>
            <div class="dropdown-menu shadow-sm">
                <a @click="createElement('video')" v-show="allowedElementTypes.includes('video')" class="dropdown-item">
                    <span class="icon icon-glyphicons-basic-square-empty-upload mr-2"></span>
                    <span>Upload</span>
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" v-show="allowedElementTypes.includes('vimeo')" @click="createElement('vimeo')">
                    <img src="/static/general/img/icons/vimeo.svg" height="17" alt="Tree-structure icon" class="mr-2" />
                    <span>Vimeo</span>
                </a>
                <a
                    class="dropdown-item"
                    v-show="allowedElementTypes.includes('youtube')"
                    @click="createElement('youtube')"
                >
                    <img
                        src="/static/general/img/icons/youtube.svg"
                        height="17"
                        alt="Tree-structure icon"
                        class="mr-2"
                    />
                    <span>YouTube</span>
                </a>
                <a @click="createElement('vr')" v-show="allowedElementTypes.includes('vr')" class="dropdown-item">
                    <span class="icon icon-glyphicons-basic-square-empty-upload mr-2"></span>
                    <span>Upload</span>
                </a>
            </div>
        </div>
        <a
            v-show="allowedElementTypes.includes('downloadable')"
            @click="createElement('downloadable')"
            class="badge badge-light badge-pill mr-2"
        >
            <span class="icon icon-glyphicons-basic-plus mr-1"></span> Downloadable
        </a>
        <a
            v-show="allowedElementTypes.includes('pdf')"
            @click="createElement('pdf')"
            class="badge badge-light badge-pill mr-2"
        >
            <span class="icon icon-glyphicons-basic-plus mr-1"></span> PDF
        </a>
        <a
            v-show="allowedElementTypes.includes('iframe')"
            @click="createElement('iframe')"
            class="badge badge-light badge-pill"
        >
            <span class="icon icon-glyphicons-basic-plus mr-1"></span> iframe
        </a>
    </div>
</template>

<script>
import AiBadge from "@/components/AiBadge"

export default {
    name: "RichContentOptions",
    props: {
        allowedElementTypes: {
            type: Array,
            required: true,
        },
    },
    components: {
        AiBadge,
    },
    computed: {
        freeTierActive() {
            return this.$store.getters.freeTierActive
        },
        videoElementsAllowed() {
            return (
                this.allowedElementTypes.includes("video") ||
                this.allowedElementTypes.includes("youtube") ||
                this.allowedElementTypes.includes("vimeo") ||
                this.allowedElementTypes.includes("vr")
            )
        },
    },
    methods: {
        createElement(elementType) {
            this.$emit("create", elementType)
        },
    },
}
</script>

<style>
</style>